import React from "react";
import Button from "../../components/button/button";
import { useNavigate } from "react-router-dom";
import Section from "../../components/section";
import background from "../../assets/backgrounds/landing-4.svg";
import lighthouse from "../../assets/lighthouse_image.png";

type Props = {};

const Newsletter = (props: Props) => {
  const navigate = useNavigate();

  return (
    <Section backgroundImage={background} id="newsletter">
      <div className="container px-5 flex flex-col justify-center items-center h-screen">
        <div className="flex flex-col mb-6">
          <p className="text-4xl font-bold text-[#4B010E]">
            Interested? Join our newsletter
          </p>
          <p className="text-5xl font-bold text-[#F93712] text-center">
            Lighthouse:
          </p>
          <p className="text-3xl font-bold text-[#F93712] text-center">
            Guiding the Straits
          </p>
        </div>
        <p className="text-[#4B010E] text-opacity-80 text-base md:text-2xl text-center mb-10">
          Lighthouse is an e-magazine that spotlights Singaporeans making waves
          in the social innovation sector and those with extraordinary
          accomplishments. We navigate the inspiring stories steering our nation
          forward.
        </p>
        <div className="w-full flex justify-center my-5">
          <Button theme="primary" onClick={() => navigate("/lighthouse")}>
            Read More
          </Button>
        </div>
      </div>
      <img
        src={lighthouse}
        className="h-1/2 bottom-0 absolute -z-10 hidden md:block"
      />
    </Section>
  );
};

export default Newsletter;
